/**
 * Which period the Visits board opens on, from tenant policy.
 *
 * Two vocabularies meet here and neither may leak into the other: `PlannedWorkPeriodPreset` is what
 * the tenant SETTING persists, and `FilterPeriodPreset` is what the board engine understands. They
 * name the same stretches of time, so the map below is 1:1 and exhaustive — a new member on either
 * side fails to compile rather than silently falling back.
 */

import { GeneralSetting, PlannedWorkPeriodPreset, getPlannedWorkSettings } from '@jms/model';
import { FilterPeriodPreset } from '@workbuddy/ui/v2/blocks/filter';

const SETTING_TO_PRESET: Readonly<Record<PlannedWorkPeriodPreset, FilterPeriodPreset>> = {
  [PlannedWorkPeriodPreset.ThisWeek]: FilterPeriodPreset.ThisWeek,
  [PlannedWorkPeriodPreset.NextWeek]: FilterPeriodPreset.NextWeek,
  [PlannedWorkPeriodPreset.ThisFortnight]: FilterPeriodPreset.ThisFortnight,
  [PlannedWorkPeriodPreset.NextFortnight]: FilterPeriodPreset.NextFortnight,
  [PlannedWorkPeriodPreset.ThisMonth]: FilterPeriodPreset.ThisMonth,
  [PlannedWorkPeriodPreset.NextMonth]: FilterPeriodPreset.NextMonth,
};

export function toFilterPeriodPreset(preset: PlannedWorkPeriodPreset): FilterPeriodPreset {

  return SETTING_TO_PRESET[preset];
}

export function visitListDefaultPreset(settings: GeneralSetting | null | undefined): FilterPeriodPreset {

  return toFilterPeriodPreset(getPlannedWorkSettings(settings).visitListDefaultPeriod);
}

export function visitApprovalDefaultPreset(settings: GeneralSetting | null | undefined): FilterPeriodPreset {

  return toFilterPeriodPreset(getPlannedWorkSettings(settings).visitApprovalDefaultPeriod);
}
